import _ from "lodash";

import { ApplyPage } from "../app/apply-page/apply-page";

const _routes = {
  "/": {
    component: <ApplyPage />,
  },
} as const;

const customKebab = (string: string) => {
  return string
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/[\s_]+/g, "-")
    .toLowerCase();
};

export const buildRoutesArray = (routes: {
  [k: string]: {
    component: React.ReactNode;
  };
}): {
  path: string;
  component: React.ReactNode;
}[] => {
  return Object.entries(_routes).map(([route, { component }]) => {
    const kebabPath = customKebab(route);
    return {
      path: kebabPath.startsWith("/") ? kebabPath : `/${kebabPath}`,
      component,
    };
  });
};

export const routes = Object.entries(_routes).reduce(
  (acc, [route, { component }]) => {
    const kebabPath = _.kebabCase(route);
    return {
      [route]: {
        component,
        path: () => (kebabPath.startsWith("/") ? kebabPath : `/${kebabPath}`),
      },
      ...acc,
    };
  },
  {},
) as {
  [k in keyof typeof _routes]: {
    component: React.ReactNode;
    path: () => string;
  };
};
